import React, { useState } from 'react'
import { supabase } from '../utils/supabaseClient'
import {
  Box, Card, CardContent, TextField, Button, Typography, Tab, Tabs, Alert, CircularProgress,
} from '@mui/material'

interface AuthProps {
  onAuthSuccess: () => void
}

const Auth: React.FC<AuthProps> = ({ onAuthSuccess }) => {
  const [tab, setTab] = useState(0)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [confirmPassword, setConfirmPassword] = useState('')
  const [error, setError] = useState('')
  const [message, setMessage] = useState('')
  const [loading, setLoading] = useState(false)

  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    const { error } = await supabase.auth.signInWithPassword({ email, password })
    if (error) setError(error.message)
    else onAuthSuccess()
    setLoading(false)
  }

  const handleRegister = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    if (password.length < 6) { setError('密码至少6个字符'); return }
    if (password !== confirmPassword) { setError('两次密码不一致'); return }
    setLoading(true)
    const { error } = await supabase.auth.signUp({ email, password })
    if (error) setError(error.message)
    else setMessage('注册成功！请查收验证邮件。')
    setLoading(false)
  }

  const handleForgotPassword = async () => {
    if (!email) { setError('请输入邮箱'); return }
    setError('')
    setLoading(true)
    const { error } = await supabase.auth.resetPasswordForEmail(email, {
      redirectTo: `${window.location.origin}/reset`,
    })
    if (error) setError(error.message)
    else setMessage('重置密码邮件已发送，请查收。')
    setLoading(false)
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh', bgcolor: '#0a0a0a' }}>
      <Card sx={{ maxWidth: 400, width: '100%', mx: 2, bgcolor: '#1a1a2e', color: '#fff' }}>
        <CardContent sx={{ p: 3 }}>
          <Typography variant="h4" align="center" gutterBottom sx={{ fontWeight: 'bold' }}>
            Mini Movie
          </Typography>

          <Tabs
            value={tab}
            onChange={(_, v) => { setTab(v); setError(''); setMessage('') }}
            centered
            sx={{ mb: 2, '& .MuiTab-root': { color: '#aaa' }, '& .Mui-selected': { color: '#e50914' } }}
          >
            <Tab label="登录" />
            <Tab label="注册" />
          </Tabs>

          {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
          {message && <Alert severity="success" sx={{ mb: 2 }}>{message}</Alert>}

          {tab === 0 ? (
            <form onSubmit={handleLogin}>
              <TextField
                fullWidth label="邮箱" type="email" value={email} onChange={e => setEmail(e.target.value)}
                margin="normal" required sx={{ '& .MuiInputLabel-root': { color: '#aaa' }, '& .MuiOutlinedInput-root': { color: '#fff' } }}
              />
              <TextField
                fullWidth label="密码" type="password" value={password} onChange={e => setPassword(e.target.value)}
                margin="normal" required sx={{ '& .MuiInputLabel-root': { color: '#aaa' }, '& .MuiOutlinedInput-root': { color: '#fff' } }}
              />
              <Button
                fullWidth type="submit" variant="contained" disabled={loading}
                sx={{ mt: 2, mb: 1, bgcolor: '#e50914', '&:hover': { bgcolor: '#b20710' } }}
              >
                {loading ? <CircularProgress size={24} /> : '登录'}
              </Button>
              <Button onClick={handleForgotPassword} disabled={loading} sx={{ color: '#aaa', textTransform: 'none' }}>
                忘记密码？
              </Button>
            </form>
          ) : (
            <form onSubmit={handleRegister}>
              <TextField
                fullWidth label="邮箱" type="email" value={email} onChange={e => setEmail(e.target.value)}
                margin="normal" required sx={{ '& .MuiInputLabel-root': { color: '#aaa' }, '& .MuiOutlinedInput-root': { color: '#fff' } }}
              />
              <TextField
                fullWidth label="密码" type="password" value={password} onChange={e => setPassword(e.target.value)}
                margin="normal" required sx={{ '& .MuiInputLabel-root': { color: '#aaa' }, '& .MuiOutlinedInput-root': { color: '#fff' } }}
              />
              <TextField
                fullWidth label="确认密码" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
                margin="normal" required sx={{ '& .MuiInputLabel-root': { color: '#aaa' }, '& .MuiOutlinedInput-root': { color: '#fff' } }}
              />
              <Button
                fullWidth type="submit" variant="contained" disabled={loading}
                sx={{ mt: 2, bgcolor: '#e50914', '&:hover': { bgcolor: '#b20710' } }}
              >
                {loading ? <CircularProgress size={24} /> : '注册'}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </Box>
  )
}

export default Auth
